import { useIntl } from 'react-intl';

import { StyledModal } from 'common/components';
import CreateProductForm from './CreateProductForm';
import CreateProductModalFooter from './CreateProductModalFooter';

import { useDispatchReloadPage } from 'hooks/useReloadPage';
import useCreateProduct from 'hooks/createProductHooks';
import { useGetProductFullView } from 'hooks';

import messages from 'i18n/messages/product';

import './CreateProductViaFormModal.less';

function CreateProductViaFormModal({
  setAddModalVisible,
  addModalVisible,
  isEdit,
  memberId,
  productId,
}) {
  const intl = useIntl();
  const reloadPage = useDispatchReloadPage();

  const handleOk = () => {
    submitForm();
  };

  const handleCancel = () => {
    resetFormState();
    setAddModalVisible(false);
  };

  const { productFull } = useGetProductFullView({ productId });

  const { submitForm, formLoading, resetFormState, ...createProductFormProps } =
    useCreateProduct({
      modalVisible: addModalVisible,
      productDetail: productFull,
      isEdit,
      reloadPage,
      callApiCallback: handleCancel,
      memberId: memberId,
      productId,
    });

  const modalProps = {
    title: isEdit
      ? intl.formatMessage(messages.editProduct)
      : intl.formatMessage(messages.addProduct),
    visible: addModalVisible,
    width: '85%',
    closable: true,
    maskClosable: false,
    onCancel: handleCancel,
    // wrapClassName: 'document-modal',
  };

  return (
    <div>
      <StyledModal
        {...modalProps}
        isLoading={formLoading}
        loadingContent={{ loadingText: 'Loading' }}
        centered
        footer={
          <CreateProductModalFooter
            onCancel={handleCancel}
            onOk={handleOk}
            okLoading={formLoading}
            disabledOkButton={false}
          />
        }
      >
        <CreateProductForm
          {...createProductFormProps}
          memberIdBrand={memberId}
        />
      </StyledModal>
    </div>
  );
}

export default CreateProductViaFormModal;
